import { render, staticRenderFns } from "./_base-group-select.vue?vue&type=template&id=2642e9e3&scoped=true&"
import script from "./_base-group-select.vue?vue&type=script&lang=js&"
export * from "./_base-group-select.vue?vue&type=script&lang=js&"
import style0 from "./_base-group-select.vue?vue&type=style&index=0&id=2642e9e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642e9e3",
  null
  
)

export default component.exports